module.exports = __webpack_public_path__ + "static/media/image29.a799b11c.jpeg";